import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Spinner } from '@nvision/ui';

import { TabsLayout } from '@/components/tabs-layout';

import { LazyProjects } from './components/projects/projects.lazy';
import { LazyTender, LazyTenderNew } from './components/tender';
import { LazyTenders } from './components/tenders/tenders.lazy';
import { ROUTES } from './config';

const TABS = [
  { label: 'Projects', to: ROUTES.projects() },
  { label: 'Tenders', to: ROUTES.tenders() },
];

export const routes = {
  root: {
    Component: () => (
      <TabsLayout tabs={TABS}>
        <Suspense fallback={<Spinner size="sm" />}>
          <Outlet />
        </Suspense>
      </TabsLayout>
    ),
    path: ROUTES.index(),
  },
  routes: [
    {
      Component: () => <Navigate replace to={ROUTES.projects()} />,
      index: true,
    },
    {
      Component: () => (
        <>
          <LazyProjects />
          <Outlet />
        </>
      ),
      path: ROUTES.projects(),
      routes: [],
    },
    {
      Component: () => <LazyTenders />,
      path: ROUTES.tenders(),
    },
    {
      Component: () => <LazyTenderNew />,
      path: ROUTES.tenderNew(),
    },
    {
      Component: () => <LazyTender />,
      path: ROUTES.tender(),
    },
  ],
};
